import React from 'react';

function getTileValue(tile) {
  return typeof tile === 'object' && tile !== null ? tile.value : tile;
}

function getTileColor(tile) {
  return typeof tile === 'object' && tile !== null && tile.color ? tile.color : 'yellow';
}

const Column = ({ values, onClick, onDropTile, onDragOverTile, dropActive, dropIndex }) => (
  <div
    role="button"
    tabIndex={0}
    aria-label={`Column ${dropIndex + 1}, ${values.length} ${values.length === 1 ? 'tile' : 'tiles'}`}
    onClick={onClick}
    onKeyDown={(event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onClick();
      }
    }}
    onDrop={onDropTile}
    onDragOver={onDragOverTile}
    data-drop-zone="true"
    data-drop-type="column"
    data-drop-index={dropIndex}
    className={`well column ${dropActive ? 'drop-active' : ''}`}
  >
    {values.length === 0 && (
      <span className="column-hint" aria-hidden="true">
        Empty
      </span>
    )}
    {values.map((tile, idx) => (
      <span
        className={`counter counter-${getTileColor(tile)}`}
        key={tile?.id ?? `${idx}-${getTileValue(tile)}`}
        style={{ zIndex: idx + 1 }}
      >
        {getTileValue(tile)}
      </span>
    ))}
  </div>
);

export default Column;
